import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import BookAppointment from "./pages/BookAppointment";

function App() {
  return (
    <Router>
      {/* Fixed Header */}
      <header
        style={{
          backgroundColor: "#2563eb",
          color: "white",
          padding: "15px 40px",
          boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        <nav
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Link
            to="/"
            style={{
              fontWeight: "bold",
              fontSize: "22px",
              letterSpacing: "0.5px",
              color: "#fff",
              textDecoration: "none",
            }}
          >
            A V Medical Centre
          </Link>

          <div
            style={{
              display: "flex",
              gap: "25px",
              alignItems: "center",
              fontSize: "17px",
              fontWeight: "500",
            }}
          >
            <Link
              to="/"
              style={{
                color: "white",
                textDecoration: "none",
                padding: "6px 12px",
                borderRadius: "6px",
                transition: "all 0.3s ease",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#1e3a8a";
                e.target.style.color = "#f1f5f9";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "white";
              }}
            >
              Home
            </Link>

            <Link
              to="/book-appointment"
              style={{
                color: "#fff",
                backgroundColor: "#1e40af",
                padding: "8px 16px",
                borderRadius: "6px",
                textDecoration: "none",
                transition: "0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#1d4ed8")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#1e40af")}
            >
              Book Appointment
            </Link>
          </div>
        </nav>
      </header>

      {/* Page Content */}
      <main
        style={{
          minHeight: "80vh",
          backgroundColor: "#f9fafb",
          padding: "30px 50px",
          marginTop: "90px",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book-appointment" element={<BookAppointment />} />
        </Routes>
      </main>

      {/* Footer */}
      <footer
        style={{
          backgroundColor: "#2563eb",
          color: "white",
          textAlign: "center",
          padding: "15px 10px",
          fontSize: "15px",
          marginTop: "30px",
          boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
        }}
      >
        © {new Date().getFullYear()} A V Medical Centre | All Rights Reserved
      </footer>
    </Router>
  );
}

export default App;
